module.exports = __webpack_public_path__ + "img/59.13a04f2c.jpg";